import script from "./SelfComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelfComponent.vue?vue&type=script&setup=true&lang=ts"

import "./SelfComponent.vue?vue&type=style&index=0&id=3c459468&lang=scss"

const __exports__ = script;

export default __exports__